import React from "react";
import IconCloudDevOpsStrategy from "../../icons/icon-cloud-devOps-strategy.svg";
import IconCloudArchitecture from "../../icons/icon-cloud-architecture.svg";
import IconInfrastructureAutomation from "../../icons/icon-infrastructure-automation.svg";
import IconCloudMigration from "../../icons/icon-cloud-migration.svg";
import IconCICDAutomation from "../../icons/icon-CICD-automation.svg";
import IconkubernetesContainers from "../../icons/icon-kubernetes-containers.svg";
import IconCloudDevOps from "../../icons/icon-cloud-devOps.svg";
import IconDataOps from "../../icons/icon-dataOps.svg";
import IconIOTAnalytics from "../../icons/icon-iot-analytics.svg";
import PageBannerImage from "../../images/devops-automation-main-banner.svg";
import IconFasterTimeMarket from "../../icons/icon-faster-time-market.svg";
import IconImproveTeamProductity from "../../icons/icon-improve-team-productity.svg";
import IconImproveReliabilityResiliancy from "../../icons/icon-improve-reliability-resiliancy.svg";
import IconPuppet from "../../icons/icon-puppet.svg";
import IconAnsible from "../../icons/icon-ansible.svg";
import IconChef from "../../icons/icon-chef.svg";
import IconKubernates from "../../icons/icon-Kubernates.svg";
import IconIconkibanaDO from "../../icons/icon-kibanaDO.svg";
import IconDatadog from "../../icons/icon-datadog.svg";
import IconGrafana from "../../icons/icon-grafana.svg";
import IconDocker from "../../icons/icon-docker.svg";
import IconLinux from "../../icons/icon-linux.svg";
import IconJenkins from "../../icons/icon-jenkins.svg";
import IconGithub from "../../icons/icon-Github.svg";
import IconBitBucket from "../../icons/icon-BitBucket.svg";
import IconMaven from "../../icons/icon-Maven.svg";
import IconJava from "../../icons/icon-Java.svg";
import IconAwsColor from "../../icons/icon-aws-color.svg"
import IconAzureColor from "../../icons/icon-azure-color.svg";
import IconGcpColor from "../../icons/icon-gcp-color.svg";
import IconOracleColor from "../../icons/icon-oracle-color.svg";

import IconReduceRisks from "../../icons/icon-reduce-risks.svg";

import ImageCB from "../../images/services-cs-cb.png";
import ImageCBFlexprintHalf from "../../images/service-cs-flexprint-half.jpg";
import ImageKrogerHalf from "../../images/service-cs-kroger-half.jpg";

export const mainBannerObj = {
  classes: "",
  header: (<>DevOps <br />Automation</>),
  content: "Shorten time to market, increase productivity, and gain competitive advantage with automated DevOps!",
  mediaClass: "align-v-center justify-center",
  mediaType: "image",
  mediaSource: PageBannerImage
};


export const pageIntroObj = {
  classes: "section-gap",
  title: "",
  header: (<>Continous Innovation: a capability to survive and thrive in the digital age</>),
  content: (<><p>In today's digital era, the businesses that can constantly innovate, adapt, and evolve are the ones that survive and grow. That's why many businesses are turning to DevOps to improve speed to market, enhance customer-centricity, and minimize costs associated with product development, delivery, and maintenance. DevOps creates a step-change ability for businesses to streamline and automate infrastructure, operations, and engineering functions to continuously deliver more reliable, secure, and scalable digital products and platforms.</p>

    <p>We leverage our vast experiences in delivering complex digital platforms, infrastructure, and operations to help businesses design, build, and run modern DevOps functions to continue to accelerate the delivery of secure, reliable, and top-quality products.</p>

    <p>Our experts can automate environment provisioning, configurations, testing, monitoring, and software deployments with the top open-source tech, industry best practices, and cloud infrastructure. The result: faster, responsible, and radically efficient market delivery of every digital initiative.</p></>)
};


export const blockQuoteObj = {
  classes: "md-blockquote",
  quote: "DevOps reinvented the collaboration between developers and operation teams that enabled enterprises to seize market opportunities, deliver business value faster, adapt to change easier, and overcome IT complexity with automation and cloud computing.",
  author: "Senior DevOps Architect",
  occupation: "Rapidops",
};

export const gridlayoutObj = {
  classes: "devops-build three-row-three-col-grid",
  header: "Our capabilities",
  subHeader: (<>Our end-to-end solutions and services to help you lead the digital disruption.</>),
  gridItems: [
    {
      icon: <IconCloudDevOpsStrategy />,
      header: "Cloud & DevOps Strategy",
      content: "Discover opportunities and devise the strategy to deliver tangible business value for DevOps & cloud automation"
    },
    {
      icon: <IconCloudArchitecture />,
      header: "Cloud Architecture ",
      content: "Build stable and reliable architecture that will improve the platform costs, security, and agility of all cloud-based apps and services"
    },
    {
      icon: <IconInfrastructureAutomation />,
      header: "Infrastructure Automation",
      content: "Rebuild the foundation of your business with a combination of cloud infrastructure, automation, and continuous deployment"
    },
    {
      icon: <IconCICDAutomation />,
      header: "CI/CD Automation",
      content: "Quickly and flawlessly add new features to your app to keep your customers happy and stay ahead of the competition"
    },
    {
      icon: <IconkubernetesContainers />,
      header: "Kubernetes & Containers",
      content: "Build highly scalable and portable apps with containerized deployment and resource management"
    },
    {
      icon: <IconCloudMigration />,
      header: "Cloud Migration",
      content: "Plan, architect and migrate your existing infrastructure and applications to GCP, AWS, or Azure cloud platforms"
    },
    {
      icon: <IconCloudDevOps />,
      header: "Cloud & DevOps",
      content: "Ensure faster deployments and reinforce security by using automated compliance policies, fine-grained controls, and configuration management"
    },
    {
      icon: <IconDataOps />,
      header: "DataOps",
      content: "Build robust, fault-tolerant, and cost-effective solutions for storing, processing, and analyizing a massive amount of data on cloud"
    },
    {
      icon: <IconIOTAnalytics />,
      header: "IoT Analytics",
      content: "Use IoT devices and data to deliver real-time experiences, operational process, and create smart products and services"
    }
  ]
};


export const threeColSliderObj = {
  classes: "devops-opportunity",
  header: <>How we can help companies be more agile with automated DevOps & CloudOps</>,
  subHeader: <>Shorten the development cycle, accelerate your digital transformation and move at high velocity to serve customers better.</>,
  items: [
    {
      icon: <IconFasterTimeMarket />,
      header: "Faster Time to Market",
      content: "Speed up the time to market and stay ahead of the competition to achieve faster ROI through continuous delivery approach."
    }, {
      icon: <IconImproveReliabilityResiliancy />,
      header: "Improve Reliability & Resiliancy",
      content: "Create stable, secure and highly resilient  architecture, engineering, and deployment practices for all digital apps to drive efficiency and elasticity."
    }, {
      icon: <IconImproveTeamProductity />,
      header: "Improve Team Productity",
      content: "Eliminate manual work, bring acocuntability, improve engineering productivity, and automate best practices for all teams."
    }, {
      icon: <IconReduceRisks />,
      header: "Reduce Risks",
      content: "With frequent deployments, and early identification of quality concerns reduce the risk of defects and possible human errors."
    }
  ]
};


export const techSliderObj = {
  classes: "md-technology devops-technology",
  items: [
    {
      link: "/",
      image: <IconPuppet />,
      name: "Puppet"
    }, {
      link: "/",
      image: <IconAnsible />,
      name: "Ansible"
    }, {
      link: "/",
      image: <IconChef />,
      name: "Chef"
    }, {
      link: "/",
      image: <IconKubernates />,
      name: "Kubernates"
    }, {
      link: "/",
      image: <IconIconkibanaDO />,
      name: "Kibana"
    }, {
      link: "/",
      image: <IconDatadog />,
      name: "DataDog"
    }, {
      link: "/",
      image: <IconGrafana />,
      name: "Grafana"
    }, {
      link: "/",
      image: <IconDocker />,
      name: "Docker"
    }, {
      link: "/",
      image: <IconLinux />,
      name: "Linux"
    }, {
      link: "/",
      image: <IconJenkins />,
      name: "Jenkins"
    }, {
      link: "/",
      image: <IconGithub />,
      name: "Github"
    }, {
      link: "/",
      image: <IconMaven />,
      name: "BitBucket"
    }, {
      link: "/",
      image: <IconBitBucket />,
      name: "Maven"
    }, {
      link: "/",
      image: <IconJava />,
      name: "Java"
    }
  ],
  platforms: [
    {
      icon: <IconAwsColor />,
      title: "AWS"
    }, {
      icon: <IconGcpColor />,
      title: "GCP"
    }, {
      icon: <IconAzureColor />,
      title: "Azure"
    },
    {
      icon: <IconOracleColor />,
      title: "Oracle"
    }
  ]
};

export const succesStoriesObj = {
  classesForFullColumn: "cs-cb",
  imageForFullColumn: ImageCB,
  imageAltForFullColumn: "Salesmate CRM Dashboard",
  imageTitleForFullColumn: "crm dashboard",
  categoryForFullColumn: "MANUFACTURING",
  headerForFullColumn: "Enabling digital evolution in manufacturing",
  subHeaderForFullColumn: (<>How we helped our client improve customer services and automate processes?</>),
  linkForFullColumn:'/work/digital-transformation-manufacturing/',

  classesForhalfColumn1: "cs-kroger-hlaf",
  imageForHalfColumn1: ImageKrogerHalf,
  imageAltForHalfColumn1: "custom voice automation retail",
  imageTitleForHalfColumn1: "Custom Voice Automation",
  categoryForHalfColumn1: "Retail",
  headerForHalfColumn1: "Voice-enabled shopping",
  linkForForHalfColumn1: '/work/kroger-grocery-shopping-voice-assistant/',

  classesForhalfColumn2: "cs-flexprint-hlaf",
  imageForHalfColumn2: ImageCBFlexprintHalf,
  imageAltForHalfColumn2: "Internet of things",
  imageTitleForHalfColumn2: "Iot",
  categoryForHalfColumn2: "B2B SERVICES",
  headerForHalfColumn2: "Transforming managed- printing with digital & IoT",
  linkForForHalfColumn2: '/work/transforming-managed-printing-with-iot-flexprint/',
};

export const ctaObj = {
  title: <>Let’s discuss your digital opportunity.</>,
  subtitle: "Unlock your digital transformation opportunities now!",
};